import { render } from "./yesno.vue?vue&type=template&id=4eb346c3"
import script from "./yesno.vue?vue&type=script&lang=js"
export * from "./yesno.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/yesno.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eb346c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eb346c3', __exports__)) {
    console.log('reload')
    api.reload('4eb346c3', __exports__)
  }
  
  module.hot.accept("./yesno.vue?vue&type=template&id=4eb346c3", () => {
    console.log('re-render')
    api.rerender('4eb346c3', render)
  })

}


export default __exports__